import { PERSIST_STORE_NAME } from 'constants/app.constant'
import rootReducer from './rootReducer'
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'

const middlewares = []

const persistConfig = {
	key: PERSIST_STORE_NAME,
	keyPrefix: '',
	storage,
	whitelist: ['auth', 'settings'],
	// MUST stay at level 2, because both whitelisted keys are themselves
	// combineReducers of sub-slices (`auth` -> session/user, `settings` ->
	// logo/name/announcement). The default `autoMergeLevel1` *replaces* the
	// whole `auth`/`settings` object with whatever localStorage holds, so the
	// first load after a deploy that ADDS a sub-slice sees that sub-slice
	// missing entirely -- its selector reads undefined and, with no error
	// boundary in the tree, the whole app renders a blank page. Level 2
	// shallow-merges one level deeper, so a newly added sub-slice keeps its
	// default state while the persisted siblings still rehydrate.
	// (Regression shipped and reverted this way once -- adding `announcement`
	// under `settings` blanked the dashboard for every returning user.)
	stateReconciler: autoMergeLevel2,
}

const store = configureStore({
	reducer: persistReducer(persistConfig, rootReducer()),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
})

store.asyncReducers = {}

export const persistor = persistStore(store)

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false
	}
	store.asyncReducers[key] = reducer
	store.replaceReducer(persistReducer(persistConfig, rootReducer(store.asyncReducers)))
	persistor.persist()
	return store
}

export default store